import { VisibilityConditionsData } from '@/typings/interfaces/data/conditions/visibilityConditions';
import { SettingsModel, SettingsState, SettingsType } from '@/components/layout/SettingsModel';
import { InlineHeightEnum } from '@/components/layout/typing/enums';
import { SectionType } from '@/typings/enums/enums';
import { SettingsData } from '@/typings/interfaces/data/settings/settings';
import { InlineElement } from '@/components/layout/typing/interfaces';

export class SectionSettingsModel extends SettingsModel {
  public isBackgroundForcedEnabled(): boolean {
    return this.sectionModel.getSectionType() === SectionType.POPOVER;
  }

  public getSettingsType(): SettingsType {
    return 'section';
  }

  public getDefaultPadding() {
    return 30;
  }

  protected constructElementInlineStyles(state: SettingsState): InlineElement {
    const inlineStyle = super.constructElementInlineStyles(state);

    if (state.basic?.height?.type === 'fixed' && state.basic.height.fixed) {
      inlineStyle.height = {
        type: InlineHeightEnum.FIXED,
        value: state.basic.height.fixed
      };
    } else if (state.basic?.height?.type === 'window') {
      inlineStyle.height = {
        type: InlineHeightEnum.WINDOW
      };
      inlineStyle.overflowY = 'auto';
      inlineStyle.overflowX = 'hidden';
    }

    return inlineStyle;
  }

  protected constructVisibilityConditionData(data: SettingsData): VisibilityConditionsData {
    /**
     * Type casting to number so that '0' as a string doesn't get seen as enabled.
     * Additionally, when updating the condition it changes data.show_on_x.. where as with
     * fresh pageload it changes the config.devices... So this is to take this into account.
     */
    const showOnDesktop = Number(data.show_on_desktop ?? this.sectionModel.state.config.devices.desktop ?? '1')
      ? '1'
      : '0';

    const showOnMobile = Number(data.show_on_mobile ?? this.sectionModel.state.config.devices.mobile ?? '1')
      ? '1'
      : '0';

    return {
      ...(data.advanced?.visibility_condition ?? {}),
      devices: {
        desktop: showOnDesktop,
        tablet: showOnDesktop,
        mobile: showOnMobile
      }
    };
  }

  authorSignature(): string {
    return 'Sebastian Jakobsen';
  }
}
